<template>
    <div class="sms-broadcast-inline-alerts">
        <DsInlineAlert
            v-if="showAlert && (showLengthWarning || showLengthError)"
            :type="showLengthError ? 'critical' : 'warning'"
            leading-icon
            class="too-long-alert"
        >
            <div class="too-long-content">
                <span>
                    {{ $t('sms.broadcast.inlineAlerts.tooLongMessage.prefix') }}
                    <a :href="$options.KEAP_SMS_COMPLIANCE_URL" target="_blank" rel="noopener noreferrer">
                        {{ $t('sms.broadcast.learnMore') }}
                    </a>
                    {{ $t('sms.broadcast.inlineAlerts.tooLongMessage.suffix') }}
                </span>
                <DsIconButton v-if="showLengthError" name="x" @click="showAlert = false" />
            </div>
        </DsInlineAlert>

        <DsInlineAlert
            v-if="hasInvalidCharacter"
            type="critical"
            leading-icon
            class="sms-invalid-character-alert"
        >
            <span>
                Your message can
                <strong>only contain letters and numbers.</strong>
                Your message currently has unsupported characters
                (i.e., emojis, special characters, hidden characters, images, GIFs, etc.).
                This may be the result of copy-pasting. If the problem persists,
                try re-typing your message manually.
            </span>
        </DsInlineAlert>

        <DsInlineAlert v-if="!!characterCount" type="subtle" data-qa="sms-broadcast-inline-cost-analysis">
            <span>{{ totalCostMessage }} <strong>{{ totalCostAmount }}</strong></span>
        </DsInlineAlert>
    </div>
</template>

<script>
import {
    KEAP_SMS_COMPLIANCE_URL,
    SMS_MESSAGE_LENGTH,
} from '@/components/broadcast/constants/smsBroadcast.constants';
import { getSmsDeliveryTotalCostUsd } from '@/components/broadcast/utils/smsBroadcast.util';

export default {
    KEAP_SMS_COMPLIANCE_URL,

    props: {
        characterCount: Number,
        hasInvalidCharacter: Boolean,
        numSmsSegments: Number,
        recipientCount: Number,
    },

    data() {
        return {
            showAlert: true,
        };
    },

    computed: {
        isMessageTooLong() {
            return this.$richTextBox.isMessageTooLong();
        },

        showLengthError() {
            return this.characterCount >= SMS_MESSAGE_LENGTH.SHOW_ERROR;
        },

        showLengthWarning() {
            return this.characterCount >= SMS_MESSAGE_LENGTH.SHOW_WARNING
                && this.characterCount <= SMS_MESSAGE_LENGTH.SHOW_ERROR;
        },

        totalCostAmount() {
            const amount = getSmsDeliveryTotalCostUsd({ numRecipients: this.recipientCount, numMessages: this.numSmsSegments });

            return this.$t('sms.broadcast.inlineAlerts.amount', { amount });
        },

        totalCostMessage() {
            const textMessageCount = this.$tc(
                'sms.broadcast.inlineAlerts.textMessage',
                this.numSmsSegments,
                { count: this.numSmsSegments },
            );

            const recipientCount = this.$tc(
                'sms.broadcast.inlineAlerts.recipient',
                this.recipientCount,
                { count: this.recipientCount },
            );

            return this.$t('sms.broadcast.inlineAlerts.totalCost', { textMessageCount, recipientCount });
        },
    },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
    .sms-broadcast-inline-alerts {
        display: flex;
        flex-direction: column;
        width: 100%;

        > * {
            width: 100%;
        }

        > *:not(:first-child) {
            margin-top: $spacing-100;
        }
    }

    .too-long-content {
        display: flex;
        align-items: flex-start;
    }
</style>
